/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./coupon-rules-popup.vue.js?vue&type=template&id=f490e2d4!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./coupon-rules-popup.vue?vue&type=template&id=f490e2d4"
import script from "./coupon-rules-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./coupon-rules-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./coupon-rules-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./coupon-rules-popup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./coupon-rules-popup.vue.postcss?vue&type=style&index=0&id=f490e2d4&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./coupon-rules-popup.vue?vue&type=style&index=0&id=f490e2d4&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports